import {
  GET_LIST_KIEMTRANOXAU,
  GET_LIST_KIEMTRANOXAU_SUCCESS,
  GET_LIST_KIEMTRANOXAU_FAILURE,
} from "actions/KiemTraNoXau/actionTypes";

const initialState = {
  getListKiemTraNoXauLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListKiemTraNoXau = (state, action) => ({
  ...state,
  getListKiemTraNoXauLoading: true,
});

const getListKiemTraNoXauSuccess = (state, action) => {
  return {
    ...state,
    getListKiemTraNoXauLoading: false,
    objList: action.payload,
  };
};

const getListKiemTraNoXauFailed = (state, action) => ({
  ...state,
  getListKiemTraNoXauLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_KIEMTRANOXAU:
      return getListKiemTraNoXau(state, action);
    case GET_LIST_KIEMTRANOXAU_SUCCESS:
      return getListKiemTraNoXauSuccess(state, action);
    case GET_LIST_KIEMTRANOXAU_FAILURE:
      return getListKiemTraNoXauFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
